// This is an autogenerated file. Do not modify.
export const gitDescribe = "259cbf8";